export enum MessageLevel {
    Success = "success",
    Warning = "warning",
    Info = "info",
    Danger = "danger",
}

class Messages {
    show(message: string, level: string | MessageLevel, time?: number) {

        let notifyTime = time;
        if (notifyTime === undefined) {
            notifyTime = 1000;
        }

        $("#notify-alert").removeClass("d-none");
        $("#notify-alert").addClass(`alert-${level}`);
        $("#notify-alert > #notify-message").text(message);

        setTimeout(this.clear, notifyTime);
    }
    clear() {
        console.log("clear");
    }
}

class _EasyEIA {
    private notifyTimeout: number | undefined;
    constructor() {
        this.notifyTimeout = undefined;
    }

    handleErrors(response) {
        return response;
    }

    validateForm(form) {
        form.addClass("was-validated");
        return form[0].checkValidity();
    }

    notify(message: string, level: string | MessageLevel, time?: number) {
        let notifyTime = time ?? 1000;

        $("#notify-alert").removeClass("d-none");
        $("#notify-alert").addClass(`alert-${level}`);
        $("#notify-alert > #notify-message").text(message);
        clearTimeout(this.notifyTimeout);
        this.notifyTimeout = setTimeout(EasyEIA.clearNofity, notifyTime);
    }

    clearNofity() {
        $("#notify-alert").removeClass("alert-success");
        $("#notify-alert").removeClass("alert-warning");
        $("#notify-alert").removeClass("alert-danger");
        $("#notify-alert").addClass("d-none");
    }

    ConvertFormToJSON(form) {
        const array = jQuery(form).serializeArray();
        const json = {};

        jQuery.each(array, function () {
            json[this.name] = this.value || "";
        });

        return json;
    }

    request(method,
            url,
            data,
            callback,
            responseCallback,
            errorCallback) {
        axios({
            url: url,
            method: method,
            data: data,
        })
            .then((response) => {
                if (response.status === 500) {
                    throw Error(response.statusText);
                }
                if (callback) {
                    callback(response.data);
                }
                if (responseCallback) {
                    responseCallback(response);
                }
            })
            .catch((e) => {
                if (errorCallback) {
                    errorCallback(e);
                } else {
                    if (e.response && e.response.status === 500) {
                        $("#server-error").removeClass("d-none");
                    }
                    if (errorCallback) {
                    } else {
                        console.log(e);
                    }
                }
            });
    }

    PUT(url,
        data,
        callback,
        responseCallback,
        errorCallback) {
        return EasyEIA.request(
            "put",
            url,
            data,
            callback,
            responseCallback,
            errorCallback
        );
    }

    POST(url,
         data,
         callback,
         responseCallback,
         errorCallback) {
        return EasyEIA.request(
            "post",
            url,
            data,
            callback,
            responseCallback,
            errorCallback
        );
    }

    GET(url,
        data,
        callback,
        responseCallback,
        errorCallback) {
        return EasyEIA.request(
            "get",
            url,
            data,
            callback,
            responseCallback,
            errorCallback
        );
    }
}




$("#notify-alert-button").click((e) => {
    EasyEIA.clearNofity();
});

$("#server-error-button").click((e) => {
    $("#server-error").addClass("d-none");
});

export const EasyEIA = new _EasyEIA();

document.body.addEventListener("htmx:responseError", function (e) {
    const error = e.detail.xhr.response;
    console.log(error);
    const messages = new Messages();
    messages.show(error, "danger", 1000);
    // ERRORCONT.innerHTML = error;
    // ERRORCONT.classList.remove("visually-hidden");
});

document.body.addEventListener("htmx:afterSwap", function (e) {
    flask_moment_render_all();
});
